import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Radio';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "radio"
    }}>{`Radio`}</h1>
    <p>{`Accessible and themeable form radio input component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Label, Radio } from '@rebass/forms'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box>
  <Label>
    <Radio
      name='color'
      id='red'
      value='red'
    />
    Red
  </Label>
  <Label>
    <Radio
      name='color'
      id='green'
      value='green'
    />
    Green
  </Label>
  <Label>
    <Radio
      name='color'
      id='blue'
      value='blue'
    />
    Blue
  </Label>
</Box>
`}</code></pre>
    <p>{`Note that the `}<inlineCode parentName="p">{`Label`}</inlineCode>{` component uses `}<inlineCode parentName="p">{`display: flex`}</inlineCode>{` by default to make alignment with labels simpler.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      